import { render, staticRenderFns } from "./TopicPicker.vue?vue&type=template&id=2ad4a4e4&scoped=true"
import script from "./TopicPicker.vue?vue&type=script&lang=js"
export * from "./TopicPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad4a4e4",
  null
  
)

export default component.exports